import { IProductDTO } from '../../legacy/shared-types';
import { API } from '../../providers/ApiInterceptorProvider';

export const btlProductApi = {
  getBtlProductsByAppId: async (applicationId: string) => {
    try {
      const response = await API.get<IProductDTO[]>(`/btl-applications/${applicationId}/eligible-products`);
      return response.data;
    } catch (err: any) {
      console.error(err);
      throw new Error(err.response?.data?.message ?? err);
    }
  },

  updateBtlProduct: async (applicationId: string, productId: number) => {
    try {
      const response = await API.patch<void>(`/btl-applications/${applicationId}/product`, { productId });
      return response.data;
    } catch (err: any) {
      console.error(err);
      throw new Error(err.response?.data?.message ?? err);
    }
  },
};
